const { Translator, $, Routing, utils, NProgress, _, vueForm } = window;

export {
  Translator,
  $,
  Routing,
  utils,
  NProgress,
  _,
  vueForm,
};



// WEBPACK FOOTER //
// ./assets/Core/js/common/adapters/legacy-to-modules-adapter.js